<template>
  <div>
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <div class="delivery_list">
            <h2>登録納品先の管理</h2>
            <div v-for="(delivery, index) in deliveryList" :key="'delivery-' + index">
              <div class="delivery-content">
                <div>
                  <div>{{delivery.cdeliveryName}}</div>
                  <div>
                    <div>〒{{delivery.cdeliveryPostcd}}</div>
                    <div>{{delivery.cdeliveryState}}{{delivery.cdeliveryCity}}{{delivery.cdeliveryStreet}}</div>
                  </div>
                </div>
                <div>
                  <div class="detail_btn6" @click="onDelete(delivery)">削除</div>
                </div>
              </div>
            </div>
          </div>
          <dd-pager
            :pageNo="pageNo"
            :dataCountPerPage="15"
            :totalDataCount="deliveryDestList.length"
            @paging="paging"
          />
          <div v-if="deliveryDestList && deliveryDestList.length <= 0">登録されている納品先がありません。</div>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
import axios from 'axios'
import {mapActions, mapState} from 'vuex'

import * as Api from '../../utils/Api'
import * as AppEc from '../utils/AppEc'
import {DC_URL} from '../../constants/App'
import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcPager from '../components/common/DcPager'
import DcSiteMap from '../components/common/DcSiteMap'
import LoadingModal from '../../components/common/LoadingModal'

const PRODUCT_VIEW_SIZE = 15

export default {
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-loading-modal': LoadingModal,
    'dd-pager': DcPager,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcDeliveryList',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'mypage', key: 'dcMyPage', title: 'マイページ', route: 'DcMyPage'},
        {id: 'dcDeliveryList', key: 'dcDeliveryList', title: '登録納品先の管理  ', route: 'DcDeliveryList'}
      ],
      pageNo: 1,
      delFlag: false
    }
  },
  computed: {
    // ヘッダのカート情報
    ...mapState({
      deliveryDestList: state => state.deliveryDestList
    }),
    // 表示用納品先リスト
    deliveryList: function () {
      if (!this.deliveryDestList) return []
      let startIdx = (this.pageNo - 1) * PRODUCT_VIEW_SIZE
      let endIdx = this.pageNo * PRODUCT_VIEW_SIZE
      let list = this.deliveryDestList.filter(function (element, index) {
        return (index >= startIdx && index < endIdx)
      })
      return list
    }
  },
  methods: {
    ...mapActions({getDeliveryDestList: 'loadDeliveryDest'}),
    // fetchData: function () {
    //   let payload = {}
    //   axios.get(DC_URL.ORDER + '/delivery-list', payload)
    //     .then(response => {
    //       this.deliveryList = response.data.data
    //     }).catch(error => {
    //       Api.handleError(error)
    //     })
    // },
    paging: function (selPage) {
      this.pageNo = selPage
    },
    onDelete: function (delivery) {
      if (this.delFlag) return
      this.delFlag = true
      // this.$refs.loadingModalRef.showModal(true)
      AppEc.showModal({
        title: '',
        messages: [delivery.cdeliveryName + 'を削除してよろしいですか？'],
        messageType: 'success',
        layoutType: 'layout-classic',
        modalType: 'confirm',
        textAlign: 'center',
        okBtnLabel: '削除',
        cancelBtnLabel: 'キャンセル',
        onOk: () => {
          let payload = {
            params: {
              deliveryId: delivery.cdeliveryId
            }
          }
          axios.get(DC_URL.ORDER + '/delivery-delete', payload)
            .then(response => {
              this.$store.dispatch('loadDeliveryDest')
                .then(() => {
                  this.delFlag = false
                })
            }).catch(error => {
              Api.handleError(error)
              this.delFlag = false
              // this.$refs.loadingModalRef.showModal(false)
            })
        },
        onCancel: () => {
          this.delFlag = false
          // this.$refs.loadingModalRef.showModal(false)
        }
      })
    }
  },
  mounted: function () {
    this.$store.dispatch('loadDeliveryDest', {reload: true})
  },
  created: function () {
    // this.fetchData()
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcDeliveryList.vue